module.exports = __webpack_public_path__ + "static/notificationsMini-880f6f7b40adecb40884d31874e65ee1.png";